import { type KnowledgeSource } from '../../../../types/ai';
import truncated from 'utils/wordsLength';

export const SourcesList = ({ sources }: { sources?: KnowledgeSource[] }) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2 rounded-sm border border-slate-700/60 bg-slate-900/60 p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Källor</p>
      <ul className="space-y-2 text-sm text-slate-300">
        {sources.map((source) => (
          <li key={source.id} className="rounded-sm border border-slate-800/80 bg-slate-950/50 p-3">
            <p className="font-medium text-white">{source.title}</p>
            {source.snippet ? (
              <p className="mt-1 text-xs text-slate-400">{truncated(source.snippet.trim(), 20)}</p>
            ) : null}
            {source.url ? (
              <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-block text-xs font-semibold text-brand hover:text-brand-light"
              >
                Använda källor
              </a>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};
